import React, { useState } from 'react';
import { InoCardProps } from './InoCard.types';
import { useMappedKeydown } from '../../hooks/useMappedKeydown';
import { InoImage } from '../InoImage/InoImage';

export const InoCard: React.FC<InoCardProps> = ({
  title,
  children,
  isActive = false,
  classNames = '',
  imageSrc,
  hoverable = true,
  width,
  height,
  rounded = false,
  onUp,
  onDown,
  onLeft,
  onRight,
  onOk,
  onBack,
  onMouseEnter,
  onMouseLeave,
}) => {
  const [isActiveOnHover, setIsActiveOnHover] = useState(false);

  useMappedKeydown({
    isActive,
    onUp,
    onDown,
    onLeft,
    onRight,
    onOk,
    onBack,
    onMouseEnter,
    onMouseLeave,
  });

  const style: React.CSSProperties = {
    ...(width && { width: `${width}rem` }),
    ...(height && { height: `${height}rem` }),
  };

  return (
    <div
      className={`
        ino-card
        ${isActive || isActiveOnHover ? 'ino-card--active' : ''} ${
        hoverable ? 'ino-card--hoverable' : ''
      } ${classNames} ${rounded ? 'rounded' : ''}
      `}
      style={style}
      onClick={(e) => onOk?.(e as any)}
      onMouseEnter={(e) => {
        setIsActiveOnHover(true);
        onMouseEnter?.(e as any);
      }}
      onMouseLeave={(e) => {
        setIsActiveOnHover(false);
        onMouseLeave?.(e as any);
      }}
      role="button"
      tabIndex={0}
    >
      {imageSrc && (
        <div className="ino-card__media">
          <InoImage
            src={imageSrc}
            alt={title || ''}
            width={width}
            height={height}
          />
        </div>
      )}
      <div className="ino-card__content">
        {title && <h3 className="ino-card__title">{title}</h3>}
        {children ? children : null}
      </div>
    </div>
  );
};

export default InoCard;
